function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { Controls } from 'shared/helper/form';
import { FILE_STATUS } from '../constants';
var MultiFieldValidation = Controls.MultiFieldValidation;
var namespacedFilesFinished = function namespacedFilesFinished(files) {
  return (files === null || files === void 0 ? void 0 : files.length) > 0 ? files.filter(function (f) {
    return f.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING;
  }).length === 0 : true;
};
var namespacedFilesValid = function namespacedFilesValid(files) {
  return (files === null || files === void 0 ? void 0 : files.length) > 0 && files.filter(function (f) {
    return f.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING;
  }).length === 0 && files.filter(function (f) {
    return f.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
  }).length > 0;
};
var FileValidation = function FileValidation(_ref) {
  var name = _ref.name,
    required = _ref.required;
  return /*#__PURE__*/React.createElement(MultiFieldValidation, {
    name: "".concat(name, "Valid"),
    messages: {
      filesValid: 'file-upload-error'
    },
    validators: {
      filesValid: function filesValid(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          uploadedFiles = _ref3[0];
        return required ? namespacedFilesValid(uploadedFiles) : namespacedFilesFinished(uploadedFiles);
      }
    },
    fields: [name],
    useEffectArrayFieldTransform: function useEffectArrayFieldTransform(fieldValue) {
      return JSON.stringify({
        fieldValue: fieldValue,
        required: required
      });
    },
    styles: {
      error: 'error mt-2'
    }
  });
};
export default FileValidation;